import { datadogRum } from '@datadog/browser-rum';

export const sendException = (exception: unknown, context?: Record<string, unknown>) => {
  datadogRum.addError(exception, context);
};
